import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    index: string
    label: string
    className?: string
}

export const SectionLabel: FC<SectionLabelProps> = ({ index, label, className }): ReactNode => {
    return (
        <p className={cn('flex items-center gap-3 font-mono text-xs font-bold uppercase tracking-[0.2em]', className)}>
            <span className='rounded-full border border-current px-2.5 py-1'>
                {index}
            </span>

            <span>
                {label}
            </span>

            <span aria-hidden='true' className='h-px w-12 bg-current' />
        </p>
    )
}
